import React from "react";
import { Input } from "../../../../components/common/Input";

type Props = {
    telegram: string;
    whatsapp: string;
    instagram: string;
    onChange: (field: "telegram" | "whatsapp" | "instagram", value: string) => void;
};

export const ContactFields: React.FC<Props> = ({ telegram, whatsapp, instagram, onChange }) => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input label="Telegram" name="telegram" value={telegram} onChange={(v) => onChange("telegram", v)} type="text" placeholder="@username" />
        <Input label="WhatsApp" name="whatsapp" value={whatsapp} onChange={(v) => onChange("whatsapp", v)} type="text" placeholder="+79991234567" />
        <div className="md:col-span-2">
            <Input label="Instagram" name="instagram" value={instagram} onChange={(v) => onChange("instagram", v)} type="text" placeholder="@handle" />
        </div>
    </div>
);
